import Vue from 'vue';

export default Vue.extend({
  name: 'EditRowMixin',

  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    save(isNew: boolean): void {
      this.$emit('save', isNew);
    },
    clear(): void {
      this.$emit('clear');
    },
  },
});
